import {FC, SVGProps} from 'react';

export const IconLogo: FC<SVGProps<SVGSVGElement>> = ({
    width = '69',
    height = '60',
    ...rest
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 69 60"
            fill="none"
            {...rest}
        >
            <path
                d="M22.525 0.896483C23.933 0.747857 25.2748 1.19364 26.569 1.78943C27.8735 2.38997 29.4593 3.30674 31.4006 4.42575L59.8618 20.8316C61.8071 21.953 63.3984 22.8677 64.5739 23.697C65.7398 24.5196 66.7995 25.4586 67.3764 26.7534C68.2078 28.6195 68.2079 30.7509 67.3764 32.617C66.7995 33.9118 65.7398 34.8509 64.5739 35.6735C63.3984 36.5027 61.8071 37.4175 59.8618 38.5388L50.4837 43.9446L48.2335 40.2138L57.6865 34.7651C59.7062 33.6009 61.0895 32.8011 62.0629 32.1144C63.0454 31.4212 63.3097 31.042 63.3979 30.8442C63.7265 30.1065 63.7265 29.2639 63.3979 28.5263C63.3098 28.3285 63.0456 27.9494 62.0629 27.256C61.0895 26.5693 59.7062 25.7695 57.6865 24.6053L29.2253 8.19944C27.2096 7.03756 25.8273 6.24317 24.7474 5.74603C23.6577 5.24438 23.1979 5.20536 22.9825 5.22806C22.1801 5.31283 21.4511 5.73422 20.977 6.38703C20.8498 6.56241 20.654 6.9802 20.5445 8.17457C20.4359 9.35843 20.4335 10.9527 20.4335 13.2793V14.8575L16.0807 11.4293C16.0879 10.0079 16.1136 8.79122 16.2067 7.77669C16.3368 6.35784 16.6208 4.97289 17.4527 3.82729C18.6519 2.17599 20.4955 1.11085 22.525 0.896483Z"
                fill="var(--raw-primary-brand)"
            />
            <path
                d="M24.5824 59.0029L46.5683 46.2706L26.4646 16.1151L22.1088 21.8112L16.0777 16.7852V24.8267L1 48.0343L4.6263 53.794L23.6245 44.5923L24.5824 59.0029Z"
                fill="var(--raw-primary-brand)"
            />
        </svg>
    );
};
